import _ from 'lodash';
import { Errors, errorsToPropertyErrors } from '../../..';

export const getFieldIssueMessages = (field: string, model: Record<string, any>, issues: Errors): string[] => {
  const id = _.get(model, field.substring(0, field.lastIndexOf('.')))?.id ?? model?.id ?? '';
  const property = _.last(field.split('.')) ?? '';
  const propertyIssues = errorsToPropertyErrors(issues?.[id] ?? []);

  return propertyIssues?.[property] ?? [];
};
